import LoadingSection from './LoadingSection';

export default LoadingSection;
